import { gql } from '@apollo/client';

export const SwitchMfaActivation = gql`
  mutation SwitchMfaActivation($immutableId: String!) {
    switchMfaActivation(immutableId: $immutableId)
  }
`;
